export interface FactionBonus {
  researchSpeed?: number
  productionSpeed?: number
  unitPower?: number
  unitSpeed?: number
  unitCost?: number
  populationCap?: number
  gatherSpeed?: number
  buildSpeed?: number
}

export interface Faction {
  id: string
  name: string
  tagline: string
  description: string
  primaryColor: number
  secondaryColor: number
  glowColor: number
  bonuses: FactionBonus
  uniqueMechanic: string
}

export const FACTIONS: Record<string, Faction> = {
  opus: {
    id: 'opus',
    name: 'Opus Collective',
    tagline: 'Through deep thought, we shall prevail',
    description: 'Extended thinking mechanic - actions have delay but are more powerful. Fewer, stronger units. Buildings have depth levels for advanced research.',
    primaryColor: 0x9b59b6,    // Purple
    secondaryColor: 0xffd700,  // Gold
    glowColor: 0xc39bd3,       // Light purple
    bonuses: {
      researchSpeed: 1.3,
      unitPower: 1.25,
      unitSpeed: 0.85,
      buildSpeed: 0.8
    },
    uniqueMechanic: 'extendedThinking'
  },
  sonnet: {
    id: 'sonnet',
    name: 'Sonnet Swarm',
    tagline: 'Flexibility is our strength',
    description: 'Context window mechanic - units gain bonuses from nearby terrain and allies. Can morph buildings and retrain units mid-game.',
    primaryColor: 0x3498db,    // Blue
    secondaryColor: 0x00ffff,  // Cyan
    glowColor: 0x5dade2,       // Light blue
    bonuses: {
      productionSpeed: 1.2,
      unitSpeed: 1.15,
      gatherSpeed: 1.1
    },
    uniqueMechanic: 'contextBonus'
  },
  haiku: {
    id: 'haiku',
    name: 'Haiku Horde',
    tagline: 'Simplicity. Speed. Scale.',
    description: 'Compression mechanic - everything is cheap, fast, fragile. Batch production (3 units for 2.5x cost). Swarm tactics, overwhelming numbers.',
    primaryColor: 0x2ecc71,    // Green
    secondaryColor: 0x90ee90,  // Light green
    glowColor: 0x58d68d,       // Medium green
    bonuses: {
      populationCap: 1.4,
      unitCost: 0.7,
      productionSpeed: 1.3,
      unitPower: 0.8
    },
    uniqueMechanic: 'batchProduction'
  }
}

export function getFaction(id: string): Faction {
  return FACTIONS[id] || FACTIONS.opus
}
